
import './comp/index.js'

import Filters from './filters/filters.js'

Vue.mixin({
    filters: Filters
});